import {
    Box,
    CircularProgress,
    Typography
} from "@mui/material";

const Loader = ({ title = "Loading..." }) => {
    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            py={3}
        >
            <CircularProgress size={100} thickness={4}
                sx={{
                    color: "#FF9800", // Progress color
                    "& .MuiCircularProgress-circle": {
                        strokeLinecap: "round", // optional for smooth edges
                    }
                }} />
            <Typography variant="body2" sx={{ mt: 2 }}>
                {title}
            </Typography>
        </Box>
    );
};

export default Loader;
